// src/App.js
import React from 'react';
import { useParams } from 'react-router-dom';
import PostPage from './PostPage';

const posts = [
    {
        id: 'a1sgxeg568',
        title: 'عکس حاج قاسم حکم طلا داشت',
        author: 'مسیح اسکندری',
        content: (
            <p>
                باطلبه هاى اهواز رفته بوديم اردوى مشهد كه خبر شهادت سردار رسيد. زمان استخاره نبود. زود دست به‌كار شديم، جلوی باب‌الجواد، ايستگاه صلواتى زديم. مداحى وعكس حاج قاسم مثل آهن‌ربا زائرهاى امام رضا (ع) را كشيد طرف ما. خیلى‌ها به نيت  حاجت وتوسل مى آمدند. عكس حاج قاسم طلا بود و كلى بانى براى بذيرایى چاى ونسكافه وميوه موكب جور شد. اردوى بچه‌ها به اسم حاج قاسم گره خورده بود؛ زيارت به نيابت ازحاجى، بريابي موكب براى حاجى، يذيرايى از زوار براى حاجى؛ اما رزق اصلى بچه‌ها شركت درتشييع حاجى بود؛ كنار ضريح آقا امام رضا (ع).


            </p>
        ),
    },


    {
        id: 'a2zb5zbzbc',
        title: 'از تلویزیون فهمیدیم',
        author: 'مهدی طرفی',
        content: (<p>
            ازهركس پرسيدم پيكر حاجى را از كدام طرف مى برند، جواب خودش را داد! اين مقدار ناهماهنگى بيش بینى شدنی بود، مثل هميشه! فايده‌اى نداشت. حدس زدم تلويزيون مراسم و محل عبور پيكر را به صورت زنده پخش كند. با برادرم زير سايه‌بان كنار خيابان نشستيم وباكوشى تلوبيون را باز كرديم، بيشتر شبكه‌هاى ملى، اهوازرا نشان مى دادند. ازروى نشانه هاى خيابان فهميديم پيكر كجاست. از كوچه پس كوچه هاى شلوغ، خودمان رابه محل تشييع رسانديم. نتوانستيم به‌سمت پيكر برويم. از دور، به ماشين نكاه مى كرديم و پيكر سردار را با حسرت بدرقه مى كرديم.
        </p>),
    },

    {
        id: 'a3lkdbfmn6',
        title: 'مرحم، مزارشهدا',
        author: 'نسترن نیکی',
        content: (<p>
            ساعت جهار صبح، يكى ازدوستانم كه خبرنگار است، از عراق تماس گرفت، گُفت: «سردار شهيد شده.» گفتم: «مسخره، اين هم شد شوخى؟!» گوشى را خاموش كردم و خوابيدم. چند دقيقه بعد گوشي ديگرم زنگ خورد. دوباره دوستم بود. باگريه گفت:«شوخى چيه؟ والله سردار رو زدن.» تمام بدنم بى حس شد. گوشى ازدستم افتاد. نمى‌دانستم چه‌كار كنم. گريه‌كنان، توى خانه دور مى‌زدم ومادرم را صدا مى‌كردم. مادرم بيدار شد و دودستى به صورتش كوبيد. خانه برايم زندان شد. آژانس گرفتم براى گلزار شهدا. رفتم سر مزار شهيد حسين معزغلامى و تا شش بعد از ظهر، همان‌جا ماندم.


        </p>),
    },

    {
        id: 'a4ad3f5v2f',
        title: 'گفت گاومیش هارا بگذارید و بروید',
        author: 'آقای امیری',
        content: (
            <p>
                درروستاى صراخيه، حجم آب زيادى وارد خانه‌ها شده بود. شرايط براى ماندن مناسب نبود. خطر، علاوه بر مردم، احشام را هم تهديد مى كرد. حاج قاسم مى‌دانست كه تقريباً همه دارايى آنها، دام هايشان بود. سردار بعد از بازديد ازاين منطقه كفت: «گاو وديگر احشام بايد منتقل شوند، امّا گاومیش دوست دار آبه وضررى بهش وارد نمى شه.» خودش دستور داد واز سپاه، تعدادى كاميون را براى انتقال احشام آوردند. گاوميش ها را هم بردند. صراخيه به كل تخريب شده‌بود ومردم نمى‌توانستند خودشان يك جا باشند وگاو وگاومیش‌هایشان جای دیگر. مردم هم سختی زیادی کشیدند، امّا وقتى تواضع وفروتنى سردار را مى‌ديدند كه از ته قلبش به فكرشان بود. آرامش بيدا مى كردند. واقعاً كلام و رفتار سردار بر آرام كردن وضعيت سيل، تأثير زيادى گذاشت.
            </p>
        ),
    },

    {
        id: 'a5kvdbf5df',
        title: 'خون‌های یکی شده',
        author: 'سردار احمد خادم سیدالشهدا',
        content: (
            <p>
                در سپاه شادگان جلسه بود. تمام مقامات استانى بودند. استاندار، فرماندارو ..... مدير جلسه حاج قاسم بود. كاملاً از شرايط منطقه اطلاع داشت. بادقت به گزارش بقيه گوش مى‌داد، گزارش بقيه را هم كه شنيد، شروع كرد به برنامه ريزى براى انتقال آب به دريا. يك به يك نظراتمان را گفتيم، كمبود امكانات زياد بود. كل كشورهم، كم و بيش، درگير سيل بود. براى رسيدن به چاره، بازار نظرات مختلف گرم شد. مشغول صحبت بوديم كه خبر دادند مهمان هاى عزيزى داريم بچه‌هاى حشدالشعبى عراق آمدند. جلسه به هم ريخت. همه رفتيم به استقبال ابومهدى وهمراهانش. صد دستگاه آمبولانس وادوات مهندسى همراهشان بود. انگار لشكر امداد غيبى بودند. انگاردر ميانة جنگ، ورق به سمت ما برگشته‌بود. وقتى فهميديم حاج قاسم چه كرده، احساس غرور داشتيم. انگار خون هاى يكى شدة ما در مبارزه با داعش، ضامنى بود بر برادرى مان.
            </p>
        ),
    },

    {
        id: 'a6dbdb454f',
        title: 'دست در دست هم',
        author: 'سید محمد آل عمران',
        content: (
            <p>
                وقتى كه مكان مراسم تشييع تغيير كرد وشد خيابان سى مترى، از پل نادرى راه افتادم. كالسكه همراهم بود وجمعيت لحظه به لحظه متراكم تر مى‌شد. همه مثل خانواده، هواى هم را داشتند. به جایى رسيديم كه ديگر امكان حركت نبود. به نفر جلو كفتم: «نوزاد همرامه وبا اين اوضاع ايستادنم وسط جمعيت خطرناكه» گفت: «شما بچه روبغل كن، كالسكه‌ش باما.» بچه را بغل زدم وآرام آرام ازدل جمعيت زدم بيرون. كالسكه هم همراه من بالاسر ده نفردست به دست شد.
            </p>
        ),
    },

    {
        id: 'a7fdsv3v21',
        title: 'First Blog Post7',
        author: 'John Doe7',
        content: "7",
    },

    {
        id: 'a8fv31v132',
        title: 'First Blog Post8',
        author: 'John Doe8',
        content: "8",
    },

    {
        id: 'a9dfv6d42f',
        title: 'First Blog Post9',
        author: 'John Doe9',
        content: "9",
    },

    {
        id: 'a10df213vf',
        title: 'First Blog Post10',
        author: 'John Doe10',
        content: "10",
    }


]

function KPWrapper() {
    const { id } = useParams();
    const post = posts.find((post) => post.id === (id));

    return post ? (
        <PostPage
            id={post.id}
            title={post.title}
            author={post.author}
            content={post.content}
        />
    ) : (
        <p>Post not found</p>
    );
}

export default KPWrapper;
